<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.activity.title')"></div>
        <!--    页面标题 end -->

<!--        活动头部区域 start -->
        <div class="banner-block">
            <div class="banner-text">{{$t('message.activity.activityBannerName')}}</div>
        </div>
<!--        活动头部区域 end -->

<!--        活动内容区域 start -->
        <div class="activity-list">

            <div v-for="(activity, index) in activityList" :key="index"
                 class="activity-block" @click="jumpTo(activity.id)">
                <div class="img-wrapper">
                    <img :src="activity.img" alt="activity">
                </div>
                <div class="bottom-wrapper">
                    <div class="desc">{{activity.name}}</div>
                    <div class="start-end-time">
                        <div class="time-block">
                            <Icon type="md-arrow-dropright-circle" size="20" color="#00C957"/>
                            <span>{{getDate(activity.start_time)}}</span>
                        </div>
                        <div class="time-block">
                            <Icon type="md-radio-button-on" size="20" color="red" />
                            <span>{{getDate(activity.end_time)}}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
<!--        活动内容区域 end -->


    </div>
</template>

<script>
  import {gotoPage, urlRequest} from "../../common/common";
  import moment from 'moment';

  export default {
    name: "Activity",

    data() {
      return {
        // 活动列表数据
        activityList: [],
      }
    },

    created() {

      // 加载接口数据
      this.loadData();

    },

    methods: {
      // 页面跳转
      jumpTo(id) {
        this.$router.push('/Activity/' + id);
      },
      // 日期格式化
      getDate(datetime) {
        return moment(datetime).format('YYYY-MM-DD');
      },

      // 获取数据
      loadData() {
        urlRequest({
          url: this.api.getActivityList,
          method: 'POST',
        }).then(res => {
          this.activityList = res.data.msg;
        });
      },

    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Activity.scss";

</style>
